// extracted by mini-css-extract-plugin
export default {"root":"ContentInfo_root__1jVc1","title":"ContentInfo_title__RQi+x","info":"ContentInfo_info__jrqAS","striped":"ContentInfo_striped__icRHt"};